import * as dateFns from 'date-fns';
import * as React from 'react';
import { useMemo } from 'react';
import { Text, View } from 'react-native';
import { s } from './styles';
function Weekday({ index, formatedWeekdays, weekdayContainerStyle, weekdayStyle, startDate, dateFormat, }) {
    const weekDay = useMemo(() => {
        if (formatedWeekdays && formatedWeekdays.length === 7) {
            return formatedWeekdays[index];
        }
        return dateFns.format(dateFns.addDays(startDate, index), dateFormat);
    }, [index, formatedWeekdays, startDate]);
    return (<View style={[s.dayContainer, weekdayContainerStyle]}>
      <Text style={weekdayStyle}>{weekDay}</Text>
    </View>);
}
const WeekdayMemo = React.memo(Weekday);
export { WeekdayMemo as Weekday };
